import {Link} from 'react-router-dom';
import * as React from 'react';
import {IChannel} from '../../../../../../data/api/models';
import Signpost from '../Signpost';

interface INoCoverAvailableProps {
    promptSingleQuote: boolean;
    channel: IChannel;
    quoteReference: string;
    callMessage: string;
    signpost: string;
}

const NoCoverAvailable = ({
                              promptSingleQuote,
                              channel,
                              quoteReference,
                              callMessage,
                              signpost,
                          }: INoCoverAvailableProps) => {
    if (signpost) {
        return (<Signpost signpost={signpost} channel={channel}/>);
    }

    return (
        <div>
            <p>
                Sorry, we are not able to complete your quotation online as we need a few more details.
            </p>
            <p>
                {callMessage} {channel.phone} quoting <strong>{quoteReference}{' '}</strong>
                who will discuss your requirements with you.
            </p>
            <p>
                We are open Monday to Friday {channel.openingHours}, closed Bank Holidays.
            </p>
        </div>
    );
};
export default NoCoverAvailable;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoice/components/NoCoverAvailable/index.tsx